import { render, staticRenderFns } from "./PontosManuaisLista.vue?vue&type=template&id=3276c2d9&"
import script from "./PontosManuaisLista.vue?vue&type=script&lang=js&"
export * from "./PontosManuaisLista.vue?vue&type=script&lang=js&"
import style0 from "./PontosManuaisLista.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports